/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Section/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import Content from './Content/index'
import ImageTitle from './ImageTitle/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Section({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Sections/Section"
  
}) {
let comparisonOrientationValueData = fromData.useDataValue({ viewPath,
context: 'comparison',
path: 'orientation',
})
let constantData = 'vertical'
let aggregateData = fromAggregate.equals(comparisonOrientationValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Section.Vertical"
  data-view-path={viewPath}
 style={{'--h-1-ZLF3dX': aggregateData ? "49%" : "100%",'--w-2-ZLF3dX': aggregateData ? "100%" : "49.8%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Section.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
<ImageTitle
  viewPath={`${viewPath}/ImageTitle`}
/>
</div>
{children}
</React.Fragment>)
}